import React from 'react';
import { GrGroup } from 'react-icons/gr';
import SidebarFlyoutNavRow from './SidebarFlyoutNavRow';
import { HR_FLYOUT_IDS } from './SidebarFlyoutContext';
import { buildHrFlyoutSections, HR_CHILD_ROUTES } from './hr/hrNavConfig';

/**
 * HR block for the desktop sidebar — section rows with contextual flyouts (Administration pattern).
 */
export default function HrNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  activeProject,
  closeMobileSidebar,
}) {
  if (!hasMenuAccessOrChild('/hr', HR_CHILD_ROUTES)) {
    return null;
  }

  const sections = buildHrFlyoutSections(hasMenuAccess, { activeProject });
  if (sections.length === 0) return null;

  return (
    <MenuItem customIcon={<GrGroup style={{ width: '24px', height: '24px' }} />} title="HR" id="hr">
      {sections.map((section) => (
        <SidebarFlyoutNavRow
          key={section.id}
          flyoutId={HR_FLYOUT_IDS[section.id]}
          label={section.label}
          flyoutTitle={section.flyoutTitle}
          items={section.items}
          SubMenuItem={SubMenuItem}
          closeMobileSidebar={closeMobileSidebar}
          indentClass="ps-5"
          flyoutWidth={360}
          alwaysFlyout
        />
      ))}
    </MenuItem>
  );
}
